<template>
    <div v-if="appData.terminatedContract" class="default-message" v-t="'message.error_contract_termination'">
    </div>
	<div v-else class="user-panel">
		<table height=100% width=100% cellpadding=0 cellspacing=0>
            <tr class="itemheader">
                <td width="50%" height="100%">
                    <div class="inner-panel">
                        <div class="scrollable">
                            <div class="treetitle" v-t="'message.title_privileges'">
                            </div>
                            <el-tree v-if="showTree"
                                class="rights-tree"
                                :props="properties"
                                :load="loadNode"
                                lazy
                                ref="tree"
                                node-key="privilegeId"
                                highlight-current
                                default-expanded-keys="{0,1}"
                                expand-on-click-node="false"
                                @node-click="handleNodeClick"
                                @node-collapse="handleNodeCollapse"
                                :render-content="renderContent">
                            </el-tree>
						</div>
                    </div>
                </td>
                <td width="50%">
                    <div class="inner-panel">
                        <div class="scrollable">
                    	    <component
                	            v-bind:selectedNode="selectedNode"
                                v-bind:appData="appData"
        	                    :is="selectedChild"
        	                    :ref="selectedChild"
        	                    @reloadTree="reloadTree">
    	                    </component>
	                    </div>
                    </div>
                </td>
            </tr>
		</table>
	</div>
</template>

<script>
import Vue from 'vue'
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';
import UserRestrictions from "./UserRestrictions.vue";
import UserRights from "./UserRights.vue";
import InitialUserRightPanel from "./InitialUserRightPanel.vue"

export default {
    data() {
        return {
            showTree: true,
            clientRights: [],
            selectedNode: null,
            properties: {
                label: 'label',
                isLeaf: 'isLeaf'
            },
        };
    },
    methods: {
        loadNode(node, resolve) {
            var data = [];
            if (node.parent == null) {
                this.clientRights = [];
                        let privilegeName = commonUtil.getMessageText(this.$i18n,"title_user_rights1");
                        data.push({
                                    privilegeId: 0,
                                    privilegeName: privilegeName,
                                    label: privilegeName,
                                    type: 0,
                                    isLeaf: false
                                });
                        privilegeName = commonUtil.getMessageText(this.$i18n,"title_app_restriction1");
                        data.push({
                                    privilegeId: 1,
                                    privilegeName: privilegeName,
                                    label: privilegeName,
                                    type: 0,
                                    isLeaf: false
                                });
                        resolve(data);
            } else {
                switch(node.data.privilegeId) {
                    case 0:
                        let rights = [];
                        rights.push({
                                    privilegeId: 6,
                                    privilegeName: constants.PRIVILEGE_TENANT_ADMIN,
                                    label: commonUtil.getPrivilegeDisplayName(this.$i18n, constants.PRIVILEGE_TENANT_ADMIN),
                                    type: 1,
                                    isLeaf: true,
                        });
                        rights.push({
                                    privilegeId: 7,
                                    privilegeName: constants.PRIVILEGE_ALERT,
                                    label: commonUtil.getPrivilegeDisplayName(this.$i18n, constants.PRIVILEGE_ALERT),
                                    type: 1,
                                    isLeaf: true,
                        });
                        resolve(rights);
                        break;
                    case 1:
                        let restrictions = [];
                        restrictions.push({
                                    privilegeId: 2,
                                    privilegeName: constants.RESTRICTION_LOGOUT,
                                    label: commonUtil.getPrivilegeDisplayName(this.$i18n, constants.RESTRICTION_LOGOUT),
                                    type: 2,
                                    isLeaf: true,
                        });
                        restrictions.push({
                                    privilegeId: 3,
                                    privilegeName: constants.RESTRICTION_PEER_TO_PEER,
                                    label: commonUtil.getPrivilegeDisplayName(this.$i18n, constants.RESTRICTION_PEER_TO_PEER),
                                    type: 2,
                                    isLeaf: true,
                        });
                        restrictions.push({
                                    privilegeId: 4,
                                    privilegeName: constants.RESTRICTION_MAP_TAB,
                                    label: commonUtil.getPrivilegeDisplayName(this.$i18n, constants.RESTRICTION_MAP_TAB),
                                    type: 2,
                                    isLeaf: true,
                        });
                        restrictions.push({
                                    privilegeId: 5,
                                    privilegeName: constants.RESTRICTION_CHAT_TAB,
                                    label: commonUtil.getPrivilegeDisplayName(this.$i18n, constants.RESTRICTION_CHAT_TAB),
                                    type: 2,
                                    isLeaf: true,
                        });
                        restrictions.push({
                                    privilegeId: 10,
                                    privilegeName: constants.RESTRICTION_CHAT_SEND,
                                    label: commonUtil.getPrivilegeDisplayName(this.$i18n, constants.RESTRICTION_CHAT_SEND),
                                    type: 2,
                                    isLeaf: true,
                        });
                        restrictions.push({
                                    privilegeId: 8,
                                    privilegeName: constants.RESTRICTION_SAVE_CONTENTS,
                                    label: commonUtil.getPrivilegeDisplayName(this.$i18n, constants.RESTRICTION_SAVE_CONTENTS),
                                    type: 2,
                                    isLeaf: true,
                        });
                        restrictions.push({
                                    privilegeId: 8,
                                    privilegeName: constants.RESTRICTION_MODIFY_NAME,
                                    label: commonUtil.getPrivilegeDisplayName(this.$i18n, constants.RESTRICTION_MODIFY_NAME),
                                    type: 2,
                                    isLeaf: true,
                        });
                        resolve(restrictions);
                        break;
                }
            }
        },
        handleNodeClick(data, node, elNode) {
            this.selectedNode = node;
        },
        handleNodeCollapse(data, node, elNode) {
            node.expand();
        },
        renderContent(h, { node, data, store }) {
            let objectIcon = "";
            let height = "20px";

            switch (data.type) {
                case 0:             // root
                    objectIcon = require("../assets/icon_client_setting_group.svg");
                    break;
                case 1:             // rights user
                case 2:             // restriction peer
                    objectIcon = require("../assets/square_green.svg");
                    height = "6px";
                    break;
            }

            return h("span", [h("img", { attrs: { src: objectIcon ,height: height, style: "vertical-align: middle" } }), h("span", node.label)]);
        },
        reloadTree() {
            this.showTree = false;
            this.$nextTick(() => {
                 this.showTree = true
            })
        },
    },
    created: function() {
    },
    mounted: function() {
    },
    computed: {
        selectedChild: function() {
            if (this.selectedNode != null) {
                switch (this.selectedNode.data.type) {
                    case 0:
                        if (this.selectedNode.data.privilegeId == 0) {
                            return "UserRights";
                        } else {
                            return "UserRestrictions";
                        }
                    case 1:
                        return "UserRights";
                    case 2:
                        return "UserRestrictions";
                }
            }
            this.appData.selectedMenu = 'restrictions';
            return "InitialUserRightPanel";
        }
    },
    components: {
        UserRestrictions: UserRestrictions,
        UserRights: UserRights,
        InitialUserRightPanel: InitialUserRightPanel
    },
    watch: {
        '$i18n.locale' () {
            this.reloadTree();
        },
        '$route' (to, from) {
            if (to.name == "Restrictions") {
                this.$refs.tree.setCurrentKey(null);
                this.selectedNode = null;
            }
        }
    },
    props: ['appData']
}
</script scoped>

<style scoped>

table {
    border-collapse: collapse;
}

.treetitle {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 20px;
    font-size: 12px;
    width: 100%;
    vertical-align: middle;
    background-color: #f6f6f6;
    color: #848991;
}

.user-panel {
	height: 100%;
	background-color: #ffffff;
}

.inner-panel {
	position:relative;
    height: 100%;
    margin: 0;
    padding: 0;
    overflow: auto;
	background-color: #ffffff;
}

.scrollable {
	overflow: auto;
	position: absolute;
	top: 0;
	right:0;
	bottom: 0;
	left: 0;
    border-top: solid;
    border-color: #eee;
    border-width: 1px;
}

.command-area {
    background-color: #ecf1fa;
    width: 100%;
    display: block;
    text-align: left;
    padding-left: 20px;
    height: 56px;
    vertical-align: bottom;
}
.command-area-left {
    padding-top: 10px;
    padding-bottom: 10px;
    vertical-align: middle;
    float: left;
}
.command-area-right {
    padding-right: 24px;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align : right;
    vertical-align: middle;
}
.setting-table {
    padding-top: 20px;
    padding-left: 20px;
    width: 480px;
}

.optionItem {
    width: 500px;
}

.rights-tree.el-tree >>> .el-tree-node {
    min-width: 300px;;
}
.rights-tree.el-tree {
    overflow: auto;
}
.rights-tree.el-tree {
    width: 100%;
    height: calc(100vh - 120px);
}

</style>
